import { gql } from '@apollo/client';

const USER_LEAGUE_POINTS = gql`
  query userLeaguePoints($filter: ListTournamentRankingsEntryInput!, $rankingId: Int!) {
    userLeaguePoints(filter: $filter, rankingId: $rankingId)
  }
`;

export default USER_LEAGUE_POINTS;
